import * as Sentry from "@sentry/react";

/**
 * Development-only logger utility
 * Logs will only appear in local development, not in staging or production builds.
 * All logger.error(...) calls forward to Sentry regardless of environment.
 */

const isDevelopment = import.meta.env.DEV;

function captureToSentry(args: any[]) {
  if (!import.meta.env.VITE_SENTRY_DSN) return;
  const first = args[0];
  if (first instanceof Error) {
    Sentry.captureException(first);
  } else if (typeof first === "string") {
    const rest = args.slice(1);
    const extra = rest.length > 0 ? { extra: rest } : undefined;
    Sentry.captureMessage(first, { level: "error", ...(extra ?? {}) });
  } else {
    Sentry.captureMessage(String(first), { level: "error" });
  }
}

export const logger = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  error: (...args: any[]) => {
    if (isDevelopment) {
      console.error(...args);
    }
    captureToSentry(args);
  },

  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
};
